import { useState } from "react";

/** Barras horizontales de UNA serie (un solo tono), valor en la punta. */
export function Barras({ filas, formato, color = "var(--viz-serie)", max }: {
  filas: { etiqueta: string; valor: number | null; nota?: string }[]; formato: (v: number) => string; color?: string; max?: number;
}) {
  const m = max ?? Math.max(1e-9, ...filas.map((f) => f.valor ?? 0));
  const [activa, setActiva] = useState<number | null>(null);
  return (
    <ul className="flex flex-col gap-2.5">
      {filas.map((f, i) => {
        const pct = f.valor === null || f.valor <= 0 ? 0 : Math.max(0.005, f.valor / m);
        return (
          <li key={f.etiqueta} className="grid grid-cols-[minmax(5.5rem,8rem)_1fr] items-center gap-3 text-sm" tabIndex={0}
            onMouseEnter={() => setActiva(i)} onMouseLeave={() => setActiva(null)} onFocus={() => setActiva(i)} onBlur={() => setActiva(null)}>
            <span className="truncate text-tinta-suave" title={f.etiqueta}>{f.etiqueta}</span>
            <span className="flex items-center gap-2">
              <span className="h-4 rounded-r" style={{ width: `${pct * 80}%`, background: color, opacity: activa === null || activa === i ? 1 : 0.55 }} />
              <span className="tabular whitespace-nowrap text-xs text-tinta">{f.valor === null ? "—" : formato(f.valor)}{f.nota && <span className="text-tinta-suave"> · {f.nota}</span>}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
